module.exports = __webpack_public_path__ + "static/media/cafe_pt.87831f6a.png";